import {kioskLocation} from '../utils/kioskLocation';
import KioskSecurityBanner from '../components/KioskSecurityBanner';
import KioskStaffPhoto from '../components/KioskStaffPhoto';
import React, { useState, useEffect, useCallback } from 'react';

import KioskMaterialRequest from '../components/KioskMaterialRequest';
const API = '/api/kiosk';
const BRAND = { olive:'#556B2F', cream:'#F2EFE7', gold:'#A8893D', brown:'#3B2A21', red:'#8F2E24' };

const STAGES = [
  { key:'cutting', label:'Cutting' },
  { key:'webbing', label:'Webbing' },
  { key:'handle_preparation', label:'Handle Preparation' },
  { key:'sewing', label:'Sewing' },
  { key:'turning', label:'Turning' },
  { key:'printing', label:'Printing' },
  { key:'finishing', label:'Finishing' },
  { key:'packing', label:'Packing' },
  { key:'qc', label:'QC' },
];

const STAGE_COLORS = {
  cutting:'#EDF4FF', webbing:'#F3EEFF', handle_preparation:'#FFF3DC',
  sewing:'#E8F5EB', turning:'#FFF3DC', printing:'#E0F5F5',
  finishing:'#F2EFE7', packing:'#E8F5EB', qc:'#FDEAEA'
};

const STATUSES = [
  { key:'pending',       label:'Pending',        color:'#8A8A8A', bg:'#F0F0F0' },
  { key:'confirmed',     label:'Completed',      color:'#1E4FAD', bg:'#EDF4FF' },
  { key:'in_production', label:'In Production',  color:'#8B5E0A', bg:'#FFF3DC' },
  { key:'printing',      label:'Printing',       color:'#6B2FA0', bg:'#F3EAFF' },
  { key:'quality_check', label:'Quality Check',  color:'#0A6B5E', bg:'#E0FFF8' },
  { key:'ready',         label:'Ready',          color:'#2E6B3A', bg:'#E8F5EB' },
  { key:'dispatched',    label:'Dispatched',     color:'#556B2F', bg:'#F2EFE7' },
  { key:'cancelled',     label:'Cancelled',      color:'#8F2E24', bg:'#FDEAEA' },
];
const getStatus = key => STATUSES.find(s=>s.key===key) || STATUSES[0];

const STATUS_COLORS = {
  pending:{ bg:'#FFF3DC', color:'#8B5E0A', label:'Pending' },
  in_progress:{ bg:'#EDF3FF', color:'#3B5BDB', label:'In Progress' },
  ready_for_qc:{ bg:'#F0F0FF', color:'#5C5FDB', label:'Ready for QC' },
  qc_passed:{ bg:'#E8F5EB', color:'#2E6B3A', label:'QC Passed' },
  qc_failed:{ bg:'#FDEAEA', color:'#8F2E24', label:'QC Failed' },
  dispatched:{ bg:'#556B2F22', color:'#556B2F', label:'Dispatched' },
};

function lagosTime() { return new Date(Date.now() + 60*60*1000); }

function Clock() {
  const [time, setTime] = useState(lagosTime());
  useEffect(() => {
    const t = setInterval(() => setTime(lagosTime()), 1000);
    return () => clearInterval(t);
  }, []);
  return (
    <div style={{textAlign:'center'}}>
      <div style={{fontFamily:'Cormorant Garamond,serif',fontSize:'3rem',
        fontWeight:700,color:BRAND.gold,lineHeight:1}}>
        {time.toISOString().substr(11,8)}
      </div>
      <div style={{fontSize:13,color:'rgba(242,239,231,.6)',marginTop:4}}>
        {time.toLocaleDateString('en-NG',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}
      </div>
    </div>
  );
}

export default function AttendanceKiosk() {
  const [staff, setStaff] = useState([]);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [pin, setPin] = useState('');
  const [action, setAction] = useState(null);
  const [screen, setScreen] = useState('home');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [attendanceState, setAttendanceState] = useState(null);
  const [attendanceChoice, setAttendanceChoice] = useState('');
  const [jobOrders, setJobOrders] = useState([]);
  const [tasks, setTasks] = useState(null);

  // KIOSK TASK VERIFICATION ACTIONS
  const [taskAction, setTaskAction] = useState(null);
  const [taskNote, setTaskNote] = useState('');
  const [taskMessage, setTaskMessage] = useState('');

  const [countForm, setCountForm] = useState({
    production_stage:'sewing', quantity_completed:'',
    rework_count:0, issues:'', count_date:'', count_time:'', team_members:''
  });
  const [counts, setCounts] = useState([]);
  const [joFilter, setJoFilter] = useState('');
  const [stageTotals, setStageTotals] = useState({});
  const [selectedJO, setSelectedJO] = useState(null);

  const [jobsLoading, setJobsLoading] = useState(false);
  const [jobsError, setJobsError] = useState('');
  const loadJobOrders = useCallback(async () => {
    setJobsLoading(true); setJobsError('');
    try {
      const response = await fetch(API+'/job-orders', {cache:'no-store'});
      let data;
      try { data = await response.json(); } catch (_) { data = null; }
      if (!response.ok || !Array.isArray(data?.data)) {
        throw new Error(typeof data?.error === 'string' ? data.error
          : response.status === 429 ? 'Please wait before refreshing job orders again.'
          : 'Job orders could not be loaded. Tap Refresh to try again.');
      }
      setJobOrders(data.data);
    } catch (error) { setJobsError(error.message); }
    finally { setJobsLoading(false); }
  }, []);
  useEffect(() => {
    if (screen === 'job_orders' || (screen === 'count' && !selectedJO)) {
      loadJobOrders();
    }
  }, [screen, selectedJO, loadJobOrders]);

  useEffect(() => {
    let stopped=false;
    const load=()=>fetch(API+'/staff',{cache:'no-store'}).then(r=>{if(!r.ok)throw new Error('Staff unavailable');return r.json();}).then(d=>{if(!stopped)setStaff(d.data||[]);}).catch(()=>{});
    load();
    const timer=window.setInterval(load,60000);
    const visible=()=>{if(!document.hidden)load();};
    document.addEventListener('visibilitychange',visible);
    return ()=>{stopped=true;window.clearInterval(timer);document.removeEventListener('visibilitychange',visible);};
  }, []);

  useEffect(() => {
    if (result) {
      const t = setTimeout(resetAll, 8000);
      return () => clearTimeout(t);
    }
  }, [result]);

  const selectJO = async (jo) => {
    setSelectedJO(jo);
    setCounts([]);
    setStageTotals({});
    try {
      const r = await fetch(API+'/job-orders/'+jo.id+'/counts');
      const d = await r.json();
      setCounts(d.data||[]);
      setStageTotals(d.stage_totals||{});
    } catch(e) {}
  };

  const getProgress = (jo) => {
    if (!jo.quantity || jo.quantity === 0) return 0;
    return Math.min(100, Math.round(((jo.packed||0) / jo.quantity) * 100));
  };

  const resetAll = () => {
    setResult(null); setSelected(null); setPin('');
    setAction(null); setSearch(''); setScreen('home');
    setAttendanceState(null); setAttendanceChoice('');
    setCountForm({
      production_stage:'sewing',
      quantity_completed:'',
      rework_count:0,
      issues:'',
      count_date:'',
      count_time:'',
      team_members:''
    });
    setError(''); setTasks(null); setTaskAction(null); setTaskNote(''); setTaskMessage(''); setSelectedJO(null); setCounts([]); setStageTotals({});
  };

  const filtered = staff.filter(s => s.name.toLowerCase().includes(search.toLowerCase()));

  const selectStaff = (s) => {
    setSelected(s); setPin(''); setAction(null);
    setResult(null); setError(''); setScreen('menu');
    setTasks(null);
    setAttendanceState(null); setAttendanceChoice('');
  };

  const addPin = (digit) => { if (pin.length < 4) setPin(p=>p+digit); };

  const loadTasks = async () => {
    if (!selected) {
      setError('Select your name first');
      return;
    }

    if (pin.length !== 4) {
      setError('Enter your 4-digit PIN');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch(API+'/tasks', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          user_id:selected.id,
          pin
        })
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error||'Unable to load tasks');
        setPin('');
        return;
      }

      setTasks(data.data||[]);
      setPin('');
    } catch(e) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  const openTaskAction = (task, type) => {
    setTaskAction({ task, type });
    setTaskNote('');
    setTaskMessage('');
    setError('');
    setPin('');
  };

  const cancelTaskAction = () => {
    setTaskAction(null);
    setTaskNote('');
    setTaskMessage('');
    setError('');
    setPin('');
  };

  const performTaskAction = async () => {
    if (!taskAction || !selected) return;

    if (pin.length !== 4) {
      setError(
        'Enter your 4-digit PIN to confirm'
      );
      return;
    }

    if (
      taskAction.type === 'submit' &&
      taskNote.trim().length < 5
    ) {
      setError(
        'Describe the work completed before submitting'
      );
      return;
    }

    setLoading(true);
    setError('');
    setTaskMessage('');

    try {
      const endpoint =
        API +
        '/tasks/' +
        taskAction.task.id +
        '/' +
        taskAction.type;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type':'application/json'
        },
        body: JSON.stringify({
          user_id: selected.id,
          pin,
          submission_note:
            taskAction.type === 'submit'
              ? taskNote.trim()
              : undefined
        })
      });

      const data = await response.json();

      if (!response.ok) {
        setError(
          data.error ||
          'The task could not be updated'
        );
        setPin('');
        return;
      }

      if (data.data) {
        setTasks(current =>
          (current || []).map(task =>
            task.id === data.data.id
              ? {
                  ...task,
                  ...data.data
                }
              : task
          )
        );
      }

      setTaskMessage(
        data.message ||
        'Task updated successfully'
      );
      setTaskAction(null);
      setTaskNote('');
      setPin('');
    } catch (error) {
      setError(
        'Network error. Please try again.'
      );
      setPin('');
    } finally {
      setLoading(false);
    }
  };


  const loadAttendance = async () => {
    if (!selected || pin.length !== 4) return;
    setLoading(true); setError('');
    try {
      const response = await fetch(API+'/session-state', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ user_id:selected.id, pin })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Attendance could not be loaded');
      setAttendanceState(data);
      const options = data.options || [];
      const local = lagosTime();
      const hour = local.getUTCHours();
      const nightWorkDate = hour >= 20
        ? data.date
        : hour < 6
          ? new Date(Date.parse(data.date + 'T00:00:00Z') - 86400000)
              .toISOString().slice(0, 10)
          : null;
      const nightChoice = nightWorkDate
        ? options.findIndex(option =>
            option.shift_type === 'night' && option.work_date === nightWorkDate)
        : -1;
      setAttendanceChoice(String(nightChoice >= 0 ? nightChoice : 0));
      setAction(data.data ? 'sign_out' : 'sign_in');
      setPin('');
    } catch (error) {
      setError(error.message || 'Attendance could not be loaded'); setPin('');
    } finally { setLoading(false); }
  };

  const punch = async (act) => {
    if (!selected || pin.length !== 4) return;
    setLoading(true); setError('');
    try {
      const res = await fetch(API+'/punch', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ kiosk_location:await kioskLocation(), user_id: selected.id, pin, action: act||action,
          session_id:attendanceState?.data?.id,
          ...((attendanceState?.options || [])[Number(attendanceChoice)] || {}) })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error||'Something went wrong'); setPin('');
        if (res.status === 409) setAttendanceState(null);
      }
      else { setResult(data); }
    } catch(e) { setError('Network error'); }
    finally { setLoading(false); }
  };

  const submitCount = async () => {
    if (!countForm.quantity_completed) { setError('Enter quantity'); return; }
    if (pin.length !== 4) { setError('Enter your PIN to confirm'); return; }
    setLoading(true); setError('');
    try {
      const res = await fetch(API+'/job-orders/'+selectedJO.id+'/count', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ user_id: selected.id, pin, ...countForm })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error||'Failed'); setPin(''); }
      else { setResult(data); }
    } catch(e) { setError('Network error'); }
    finally { setLoading(false); }
  };

  const PinDots = () => (
    <div style={{display:'flex',justifyContent:'center',gap:8,marginBottom:16}}>
      {[0,1,2,3].map(i=>(
        <div key={i} style={{width:14,height:14,borderRadius:'50%',
          background: pin.length > i ? BRAND.gold : 'rgba(242,239,231,.2)',
          border:'2px solid rgba(168,137,61,.5)'}} />
      ))}
    </div>
  );

  const PinPad = ({onSubmit, label='✓'}) => (
    <div style={{textAlign:'center'}}>
      <PinDots />
      {error && <div style={{background:'rgba(143,46,36,.2)',borderRadius:8,padding:8,
        fontSize:12,color:'#ffaaaa',textAlign:'center',marginBottom:10}}>{error}</div>}
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10,
        maxWidth:220,margin:'0 auto'}}>
        {[1,2,3,4,5,6,7,8,9,'',0,'⌫'].map((key,i)=>(
          <button key={i} onClick={()=>{
            if (key==='⌫') setPin(p=>p.slice(0,-1));
            else if (key!=='') addPin(String(key));
          }}
          disabled={key===''}
          style={{padding:'16px',borderRadius:12,border:'none',fontSize:20,
            cursor:key===''?'default':'pointer',fontWeight:500,
            background:key===''?'transparent':'rgba(242,239,231,.1)',
            color:BRAND.cream,opacity:key===''?0:1}}>
            {key}
          </button>
        ))}
      </div>
      <button onClick={onSubmit} disabled={pin.length!==4||loading}
        style={{marginTop:16,width:'100%',maxWidth:220,padding:'14px',
          borderRadius:12,border:'none',
          background:pin.length===4?BRAND.gold:'rgba(242,239,231,.1)',
          color:pin.length===4?BRAND.brown:BRAND.cream,
          fontSize:15,fontWeight:700,cursor:'pointer'}}>
        {loading?'...' : label}
      </button>
    </div>
  );

  return (
    <div style={{minHeight:'100vh',background:BRAND.olive,display:'flex',
      flexDirection:'column',alignItems:'center',padding:'24px 16px',
      fontFamily:'Inter,sans-serif'}}>

      <KioskSecurityBanner />
      {/* Header */}
      <div style={{width:'100%',maxWidth:900,marginBottom:24}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div>
            <div style={{fontFamily:'Cormorant Garamond,serif',fontSize:'1.8rem',
              color:BRAND.cream,fontWeight:600,letterSpacing:'.05em'}}>BLOANS</div>
            <div style={{color:'rgba(242,239,231,.5)',fontSize:10,
              letterSpacing:'.2em',textTransform:'uppercase'}}>Staff Kiosk</div>
          </div>
          <Clock />
          {selected && (
            <button onClick={resetAll}
              style={{background:'rgba(0,0,0,.2)',border:'none',color:BRAND.cream,
                padding:'8px 16px',borderRadius:8,fontSize:12,cursor:'pointer'}}>
              ← Reset
            </button>
          )}
        </div>
      </div>

      {/* Result screen */}
      {result && (
        <div style={{background:'rgba(255,255,255,.95)',borderRadius:24,
          padding:40,textAlign:'center',maxWidth:400,width:'100%'}}>
          <div style={{fontSize:70,marginBottom:12}}>
            {result.action==='sign_in'?'👋':result.action==='sign_out'?'🌙':
             result.action==='break_out'?'☕':result.success?'✅':'🎉'}
          </div>
          <div style={{fontSize:24,fontWeight:700,color:BRAND.brown,
            fontFamily:'Cormorant Garamond,serif',marginBottom:8}}>
            {result.name||selected?.name}
          </div>
          <div style={{fontSize:14,color:'#555',lineHeight:1.6}}>{result.message}</div>
          {result.exceeded && (
            <div style={{marginTop:12,background:'#FDEAEA',borderRadius:8,
              padding:10,fontSize:12,color:BRAND.red}}>
              ⚠ Break exceeded 30 minute allowance
            </div>
          )}
          <div style={{marginTop:16,fontSize:11,color:'#aaa'}}>Resets in 8 seconds</div>
        </div>
      )}

      {/* STEP 1 — Staff grid */}
      {!result && screen === 'home' && (
        <div style={{width:'100%',maxWidth:900}}>
          <div style={{background:'rgba(0,0,0,.15)',borderRadius:16,padding:20}}>
            <div style={{color:BRAND.cream,fontSize:13,fontWeight:600,
              marginBottom:12,textTransform:'uppercase',letterSpacing:'.1em'}}>
              Tap your name to begin
            </div>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="Search name..."
              style={{width:'100%',padding:'10px 14px',borderRadius:10,border:'none',
                background:'rgba(0,0,0,.2)',color:BRAND.cream,fontSize:14,
                marginBottom:16,outline:'none',boxSizing:'border-box'}} />
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:10}}>
              {filtered.map(s=>(
                <button key={s.id} onClick={()=>selectStaff(s)}
                  style={{padding:'16px 12px',borderRadius:12,border:'none',
                    background:'rgba(242,239,231,.12)',color:BRAND.cream,
                    cursor:'pointer',textAlign:'center',
                    transition:'background .2s'}}>
                  <KioskStaffPhoto person={s} />
                  <div style={{fontWeight:600,fontSize:13}}>{s.name.trim()}</div>
                  <div style={{fontSize:12,color:'rgba(242,239,231,.8)',marginTop:4,
                    textTransform:'capitalize'}}>{s.role?.replace(/_/g,' ')}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* STEP 2 — Main menu tiles */}
      {!result && screen === 'menu' && selected && (
        <div style={{width:'100%',maxWidth:900}}>
          <div style={{background:'rgba(0,0,0,.15)',borderRadius:16,padding:16,
            marginBottom:16,display:'flex',alignItems:'center',gap:12}}>
            <KioskStaffPhoto person={selected} compact />
            <div>
              <div style={{color:BRAND.cream,fontWeight:600,fontSize:16}}>{selected.name}</div>
              <div style={{color:'rgba(242,239,231,.5)',fontSize:11,
                textTransform:'capitalize'}}>{selected.role?.replace(/_/g,' ')}</div>
            </div>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))',gap:12}}>
            {[
              { id:'attendance', icon:'🕐', label:'Attendance', sub:'Sign in · Sign out · Breaks' },
              { id:'tasks', icon:'✅', label:'My Tasks', sub:'PIN required to view' },
              { id:'job_orders', icon:'🧵', label:'Job Orders', sub:'View all active orders' },
              { id:'count', icon:'📊', label:'Production Count', sub:'Submit count for a job' },
            ].map(tile=>(
              <button key={tile.id} onClick={()=>{
                setPin('');
                setError('');
                if (tile.id==='tasks') setTasks(null);
                if (tile.id==='attendance') { setAttendanceState(null); setAttendanceChoice(''); setAction(null); }
                setScreen(tile.id);
              }}
                style={{padding:24,borderRadius:16,border:'none',
                  background:'rgba(242,239,231,.12)',color:BRAND.cream,
                  cursor:'pointer',textAlign:'center'}}>
                <div style={{fontSize:40,marginBottom:8}}>{tile.icon}</div>
                <div style={{fontSize:15,fontWeight:700,marginBottom:4}}>{tile.label}</div>
                <div style={{fontSize:11,color:'rgba(242,239,231,.5)'}}>{tile.sub}</div>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* ATTENDANCE: approved extra shifts use separate actual sessions. */}
      {!result && screen === 'attendance' && selected && (
        <div style={{width:'100%',maxWidth:430}}>
          <button onClick={()=>setScreen('menu')}
            style={{background:'none',border:'none',color:BRAND.cream,
              fontSize:13,cursor:'pointer',marginBottom:16}}>← Back</button>
          <div style={{background:'rgba(0,0,0,.15)',borderRadius:16,padding:24}}>
            <div style={{color:BRAND.cream,fontWeight:600,fontSize:15,
              marginBottom:16,textAlign:'center'}}>{selected.name}</div>
            {!attendanceState ? (
              <>
                <div style={{color:BRAND.cream,fontSize:12,textAlign:'center',marginBottom:12}}>
                  Enter your PIN to load your active session and approved shifts.
                </div>
                <PinPad onSubmit={loadAttendance} label="Load My Attendance" />
              </>
            ) : (
              <>
                {attendanceState.data ? (
                  <div style={{color:BRAND.cream,background:'rgba(85,107,47,.35)',padding:12,borderRadius:10,marginBottom:15,fontSize:12}}>
                    <strong>{attendanceState.data.shift_type === 'night' ? 'Night shift' : attendanceState.data.shift_type === 'weekend' ? 'Weekend work' : 'Day attendance'} is open</strong>
                    <div style={{marginTop:5}}>Work date: {String(attendanceState.data.date).slice(0,10)}</div>
                    <div style={{marginTop:5}}>Signed in: {new Date(attendanceState.data.sign_in_time).toLocaleString('en-NG',{timeZone:'Africa/Lagos'})}</div>
                    <div style={{marginTop:5}}>{attendanceState.data.shift_type === 'night' ? 'Night shift: 8 pm to 6 am. Record every break and return. A sign-out after 6 am requires Super Admin review.' : attendanceState.data.shift_type === 'weekend' || attendanceState.data.is_weekend ? 'Weekend work allows one break. Tap Break Out when leaving and Return from Break when you resume.' : 'Weekday break allowance: 30 minutes in total. Always tap Return from Break when you resume, even after 30 minutes or after the lunch window.'}</div>
                  </div>
                ) : (attendanceState.options || []).length ? (
                  <div style={{marginBottom:18}}>
                    <label htmlFor="kiosk-shift-choice" style={{display:'block',color:BRAND.cream,fontSize:12,marginBottom:8}}>Choose your approved shift</label>
                    <select id="kiosk-shift-choice" value={attendanceChoice}
                      onChange={event=>{setAttendanceChoice(event.target.value);setAction('sign_in');setPin('');}}
                      style={{width:'100%',padding:12,borderRadius:8,border:'1px solid '+BRAND.gold,fontSize:13,background:BRAND.cream,color:BRAND.brown}}>
                      {attendanceState.options.map((option,index)=>(
                        <option key={(option.shift_request_id || option.weekend_request_id || 'day')+'-'+option.work_date} value={String(index)}>
                          {option.label} · {option.work_date}
                        </option>
                      ))}
                    </select>
                    <div style={{fontSize:11,color:'rgba(242,239,231,.65)',marginTop:8}}>
                      Night and weekend work require approval. Night sign-in opens at 8 pm. Record the start and return of every break.
                    </div>
                  </div>
                ) : (
                  <div style={{color:BRAND.cream,fontSize:12,textAlign:'center',marginBottom:16}}>
                    No attendance is available now. Approved night-shift sign-in opens at 8 pm and closes at 6 am. Contact your supervisor if you need shift approval.
                  </div>
                )}
                {(attendanceState.data || (attendanceState.options || []).length > 0) && (
                  <>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:20}}>
                      {(attendanceState.data ? [
                        {act:'sign_out',label:'Sign Out',icon:'🔴'},
                        {act:'break_out',label:'Break Out',icon:'☕',disabled:Boolean(attendanceState.data.break_out && !attendanceState.data.break_in)},
                        {act:'break_in',label:'Return from Break',icon:'✅',disabled:!attendanceState.data.break_out || Boolean(attendanceState.data.break_in)},
                      ] : [{act:'sign_in',label:'Sign In',icon:'🟢'}]).map(({act,label,icon,disabled})=>(
                        <button key={act} onClick={()=>{setAction(act);setPin('');}} disabled={disabled || loading}
                          style={{padding:'12px 6px',borderRadius:10,
                            border:'2px solid '+(action===act?BRAND.gold:'transparent'),
                            background:action===act?'rgba(168,137,61,.2)':'rgba(242,239,231,.08)',
                            color:BRAND.cream,cursor:'pointer',fontSize:12,fontWeight:600,
                            opacity:disabled ? 0.4 : 1,display:'flex',flexDirection:'column',alignItems:'center',gap:4}}>
                          <span style={{fontSize:22}}>{icon}</span>{label}
                        </button>
                      ))}
                    </div>
                    <div style={{fontSize:11,color:'rgba(242,239,231,.65)',textAlign:'center',marginBottom:8}}>Re-enter your PIN to confirm.</div>
                    <PinPad onSubmit={()=>action && punch(action)} label="Confirm Attendance" />
                  </>
                )}
                <button onClick={()=>{setAttendanceState(null);setAction(null);setPin('');}} disabled={loading}
                  style={{marginTop:16,width:'100%',background:'transparent',border:'1px solid '+BRAND.gold,borderRadius:8,color:BRAND.cream,padding:10,cursor:'pointer'}}>
                  Refresh Attendance
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* TASKS */}
      {!result && screen === 'tasks' && selected && (
        <div style={{width:'100%',maxWidth:700}}>
          <button onClick={()=>setScreen('menu')}
            style={{background:'none',border:'none',color:BRAND.cream,
              fontSize:13,cursor:'pointer',marginBottom:16}}>← Back</button>
          <div style={{background:'rgba(0,0,0,.15)',borderRadius:16,padding:20}}>
            <div style={{color:BRAND.cream,fontWeight:600,fontSize:15,marginBottom:16}}>
              ✅ My Tasks {tasks !== null ? `(${tasks.length})` : ''}
            </div>
            {tasks === null ? (
              <div>
                <div style={{color:'rgba(242,239,231,.65)',textAlign:'center',
                  marginBottom:16,fontSize:13}}>
                  Enter your kiosk PIN to view your assigned tasks
                </div>
                <PinPad onSubmit={loadTasks} label="View My Tasks" />
              </div>
            ) : tasks.length === 0 ? (
              <div style={{color:'rgba(242,239,231,.4)',textAlign:'center',padding:40,fontSize:13}}>
                No tasks assigned to you today
              </div>
            ) : (
              <>
                {taskMessage && (
                  <div style={{
                    background:'rgba(85,107,47,.28)',
                    border:'1px solid rgba(168,137,61,.6)',
                    color:BRAND.cream,
                    borderRadius:8,
                    padding:10,
                    marginBottom:12,
                    fontSize:12,
                    textAlign:'center'
                  }}>
                    {taskMessage}
                  </div>
                )}

                {tasks.map(t => {
                  const production =
                    t.task_type === 'production';

                  const rejected =
                    Boolean(
                      t.verification_rejection_reason
                    );

                  return (
                    <div
                      key={t.id}
                      style={{
                        background:
                          'rgba(242,239,231,.08)',
                        borderRadius:12,
                        padding:14,
                        marginBottom:8,
                        border: rejected
                          ? '2px solid #D97066'
                          : '1px solid transparent'
                      }}
                    >
                      <div style={{
                        display:'flex',
                        justifyContent:'space-between',
                        alignItems:'flex-start'
                      }}>
                        <div style={{
                          color:BRAND.cream,
                          fontWeight:600,
                          fontSize:13,
                          flex:1
                        }}>
                          {t.title}
                        </div>

                        <span style={{
                          fontSize:9,
                          padding:'3px 8px',
                          borderRadius:20,
                          fontWeight:600,
                          flexShrink:0,
                          marginLeft:8,
                          background:
                            t.priority === 'high'
                              ? '#FDEAEA'
                              : t.priority === 'medium'
                                ? '#FFF3DC'
                                : 'rgba(242,239,231,.1)',
                          color:
                            t.priority === 'high'
                              ? '#8F2E24'
                              : t.priority === 'medium'
                                ? '#8B5E0A'
                                : BRAND.cream
                        }}>
                          {t.priority || 'normal'}
                        </span>
                      </div>

                      {t.job_number && (
                        <div style={{
                          color:BRAND.gold,
                          fontSize:10,
                          fontWeight:700,
                          marginTop:5
                        }}>
                          Job: {t.job_number}
                        </div>
                      )}

                      {t.description && (
                        <div style={{
                          color:
                            'rgba(242,239,231,.5)',
                          fontSize:11,
                          marginTop:4
                        }}>
                          {t.description}
                        </div>
                      )}

                      {rejected && (
                        <div style={{
                          background:
                            'rgba(143,46,36,.25)',
                          border:
                            '1px solid rgba(255,170,170,.5)',
                          color:'#FFD5D0',
                          borderRadius:8,
                          padding:10,
                          marginTop:10,
                          fontSize:11
                        }}>
                          <strong>
                            Returned by Precious:
                          </strong>{' '}
                          {t.verification_rejection_reason}
                        </div>
                      )}

                      {t.status ===
                        'pending_verification' && (
                        <div style={{
                          background:
                            'rgba(168,137,61,.2)',
                          color:BRAND.cream,
                          borderRadius:8,
                          padding:10,
                          marginTop:10,
                          fontSize:11,
                          textAlign:'center',
                          fontWeight:600
                        }}>
                          Awaiting physical verification
                          by Precious
                        </div>
                      )}

                      <div style={{
                        fontSize:10,
                        color:
                          'rgba(242,239,231,.4)',
                        marginTop:8,
                        display:'flex',
                        gap:12,
                        flexWrap:'wrap'
                      }}>
                        {t.due_date && (
                          <span>
                            Due{' '}
                            {new Date(
                              t.due_date
                            ).toLocaleDateString(
                              'en-NG',
                              {
                                day:'numeric',
                                month:'short'
                              }
                            )}
                          </span>
                        )}

                        <span style={{
                          textTransform:'capitalize'
                        }}>
                          {t.status
                            ?.replace(/_/g,' ')}
                        </span>
                      </div>

                      {production &&
                        t.status === 'pending' && (
                        <button
                          onClick={() =>
                            openTaskAction(
                              t,
                              'start'
                            )
                          }
                          style={{
                            width:'100%',
                            marginTop:12,
                            padding:'10px 12px',
                            borderRadius:8,
                            border:'none',
                            background:BRAND.gold,
                            color:BRAND.brown,
                            fontWeight:700,
                            cursor:'pointer'
                          }}
                        >
                          Start Task
                        </button>
                      )}

                      {production &&
                        t.status ===
                          'in_progress' && (
                        <button
                          onClick={() =>
                            openTaskAction(
                              t,
                              'submit'
                            )
                          }
                          style={{
                            width:'100%',
                            marginTop:12,
                            padding:'10px 12px',
                            borderRadius:8,
                            border:'none',
                            background:BRAND.olive,
                            color:BRAND.cream,
                            fontWeight:700,
                            cursor:'pointer'
                          }}
                        >
                          Submit for Verification
                        </button>
                      )}

                        {production &&
                          [
                            'pending',
                            'in_progress'
                          ].includes(t.status) && (
                          <KioskMaterialRequest
                            task={t}
                            user={selected}
                          />
                        )}
                    </div>
                  );
                })}

                {taskAction && (
                  <div style={{
                    marginTop:16,
                    background:'rgba(0,0,0,.22)',
                    border:
                      '1px solid rgba(168,137,61,.5)',
                    borderRadius:14,
                    padding:18
                  }}>
                    <div style={{
                      color:BRAND.cream,
                      fontWeight:700,
                      fontSize:14,
                      marginBottom:5,
                      textAlign:'center'
                    }}>
                      {taskAction.type === 'start'
                        ? 'Start Task'
                        : 'Submit for Verification'}
                    </div>

                    <div style={{
                      color:
                        'rgba(242,239,231,.65)',
                      fontSize:11,
                      marginBottom:14,
                      textAlign:'center'
                    }}>
                      {taskAction.task.title}
                    </div>

                    {taskAction.type ===
                      'submit' && (
                      <textarea
                        value={taskNote}
                        onChange={event =>
                          setTaskNote(
                            event.target.value
                          )
                        }
                        placeholder="Describe the work completed..."
                        rows={3}
                        style={{
                          width:'100%',
                          boxSizing:'border-box',
                          borderRadius:8,
                          border:
                            '1px solid rgba(242,239,231,.25)',
                          padding:10,
                          marginBottom:14,
                          fontSize:12
                        }}
                      />
                    )}

                    <div style={{
                      color:
                        'rgba(242,239,231,.65)',
                      textAlign:'center',
                      fontSize:11,
                      marginBottom:10
                    }}>
                      Re-enter your kiosk PIN
                      to confirm
                    </div>

                    <PinPad
                      onSubmit={
                        performTaskAction
                      }
                      label={
                        taskAction.type ===
                          'start'
                          ? 'Confirm Start'
                          : 'Submit Work'
                      }
                    />

                    <button
                      onClick={cancelTaskAction}
                      disabled={loading}
                      style={{
                        width:'100%',
                        background:'transparent',
                        border:
                          '1px solid rgba(242,239,231,.3)',
                        color:BRAND.cream,
                        borderRadius:8,
                        padding:9,
                        marginTop:10,
                        cursor:'pointer'
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* JOB ORDERS */}
      {!result && screen === 'job_orders' && (
        <div style={{width:'100%',maxWidth:900}}>
          <button onClick={()=>setScreen('menu')}
            style={{background:'none',border:'none',color:BRAND.cream,
              fontSize:13,cursor:'pointer',marginBottom:16}}>← Back to Menu</button>
          <button type="button" disabled={jobsLoading} onClick={loadJobOrders}
            style={{marginLeft:14,padding:'8px 14px',cursor:'pointer',borderRadius:6}}>
            {jobsLoading?'Loading orders...':'Refresh Job Orders'}
          </button>
          {jobsError && <p role="alert" style={{color:BRAND.cream,background:BRAND.red,padding:12}}>{jobsError}</p>}


          {/* Status filter tabs */}
          <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:16}}>
            <button onClick={()=>setJoFilter('')}
              style={{padding:'6px 14px',borderRadius:20,border:'none',fontSize:11,
                fontWeight:600,cursor:'pointer',
                background:joFilter===''?BRAND.cream:'rgba(242,239,231,.15)',
                color:joFilter===''?BRAND.brown:BRAND.cream}}>
              All ({jobOrders.length})
            </button>
            {STATUSES.filter(s=>s.key!=='cancelled').map(s=>{
              const count = jobOrders.filter(j=>j.status===s.key).length;
              if (!count) return null;
              return (
                <button key={s.key} onClick={()=>setJoFilter(s.key)}
                  style={{padding:'6px 14px',borderRadius:20,border:'none',fontSize:11,
                    fontWeight:600,cursor:'pointer',
                    background:joFilter===s.key?s.bg:'rgba(242,239,231,.15)',
                    color:joFilter===s.key?s.color:BRAND.cream}}>
                  {s.label} ({count})
                </button>
              );
            })}
          </div>

          {/* Tiled grid */}
          {(() => {
            const filtered = joFilter ? jobOrders.filter(j=>j.status===joFilter) : jobOrders;
            if (filtered.length === 0 && jobsLoading) return <p style={{color:BRAND.cream}}>Loading job orders...</p>;
            if (filtered.length === 0) return (
              <div style={{color:'rgba(242,239,231,.4)',textAlign:'center',padding:40,fontSize:13}}>
                No job orders in this category
              </div>
            );
            return (
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:12}}>
                {filtered.map(jo=>{
                  const st = getStatus(jo.status);
                  const progress = getProgress(jo);
                  return (
                    <div key={jo.id} style={{background:'rgba(242,239,231,.95)',
                      borderRadius:12,padding:16,display:'flex',flexDirection:'column',gap:8}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                        <span style={{fontFamily:'monospace',fontSize:12,fontWeight:700,
                          color:'#556B2F'}}>{jo.job_number}</span>
                        <span style={{fontSize:9,fontWeight:700,padding:'3px 10px',borderRadius:20,
                          background:st.bg,color:st.color,textTransform:'uppercase'}}>
                          {st.label}
                        </span>
                      </div>
                      <div style={{fontSize:13,fontWeight:600,color:'#3B2A21',lineHeight:1.3}}>
                        {jo.product_description}
                      </div>
                      <div style={{fontSize:11,color:'#8A8A8A'}}>
                      </div>
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,fontSize:11,color:'#555'}}>
                        <div>Qty: <strong>{jo.quantity}</strong></div>
                        {jo.color && <div>Color: <strong>{jo.color}</strong></div>}
                        {jo.size && <div>Size: <strong>{jo.size}</strong></div>}
                        {jo.delivery_date && <div>Due: <strong>{new Date(jo.delivery_date).toLocaleDateString('en-NG',{day:'numeric',month:'short'})}</strong></div>}
                      </div>
                      {jo.special_instructions && (
                        <div style={{fontSize:11,color:'#8F2E24',background:'#FDEAEA',
                          borderRadius:6,padding:'4px 8px'}}>
                          ⚠ {jo.special_instructions}
                        </div>
                      )}
                      <div>
                        <div style={{display:'flex',justifyContent:'space-between',
                          fontSize:10,color:'#8A8A8A',marginBottom:4}}>
                          <span>Progress</span>
                          <span>{progress}% packed</span>
                        </div>
                        <div style={{height:6,background:'#EDE7D8',borderRadius:3}}>
                          <div style={{width:progress+'%',height:6,
                            background:progress===100?'#2E6B3A':'#556B2F',borderRadius:3}}/>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>
      )}

      {/* PRODUCTION COUNT — select job (tiled) */}
      {!result && screen === 'count' && !selectedJO && (
        <div style={{width:'100%',maxWidth:900}}>
          <button onClick={()=>setScreen('menu')}
            style={{background:'none',border:'none',color:BRAND.cream,
              fontSize:13,cursor:'pointer',marginBottom:16}}>← Back to Menu</button>
          <button type="button" disabled={jobsLoading} onClick={loadJobOrders}
            style={{marginLeft:14,padding:'8px 14px',cursor:'pointer',borderRadius:6}}>
            {jobsLoading?'Loading orders...':'Refresh Job Orders'}
          </button>
          {jobsError && <p role="alert" style={{color:BRAND.cream,background:BRAND.red,padding:12}}>{jobsError}</p>}

          <div style={{fontSize:11,fontWeight:600,color:BRAND.cream,textTransform:'uppercase',
            letterSpacing:'.08em',marginBottom:12,opacity:.7}}>Tap a Job Order to Record Count</div>
          {jobsLoading && jobOrders.length === 0 ? <p style={{color:BRAND.cream}}>Loading job orders...</p> : jobOrders.length === 0 ? (
            <div style={{color:'rgba(242,239,231,.4)',textAlign:'center',padding:40,fontSize:13}}>
              No active job orders
            </div>
          ) : (
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:12}}>
              {jobOrders.map(jo=>{
                const st = getStatus(jo.status);
                const progress = getProgress(jo);
                return (
                  <div key={jo.id} onClick={()=>selectJO(jo)}
                    style={{background:'rgba(242,239,231,.95)',borderRadius:12,
                      padding:16,cursor:'pointer',display:'flex',flexDirection:'column',gap:8,
                      border:'2px solid transparent',transition:'border .15s'}}
                    onTouchStart={e=>e.currentTarget.style.border='2px solid #A8893D'}
                    onTouchEnd={e=>e.currentTarget.style.border='2px solid transparent'}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                      <span style={{fontFamily:'monospace',fontSize:12,fontWeight:700,
                        color:'#556B2F'}}>{jo.job_number}</span>
                      <span style={{fontSize:9,fontWeight:700,padding:'3px 10px',borderRadius:20,
                        background:st.bg,color:st.color,textTransform:'uppercase'}}>
                        {st.label}
                      </span>
                    </div>
                    <div style={{fontSize:13,fontWeight:600,color:'#3B2A21',lineHeight:1.3}}>
                      {jo.product_description}
                    </div>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6,fontSize:11,color:'#555'}}>
                      <div>Qty: <strong>{jo.quantity}</strong></div>
                      {jo.color && <div>Color: <strong>{jo.color}</strong></div>}
                    </div>
                    <div>
                      <div style={{display:'flex',justifyContent:'space-between',
                        fontSize:10,color:'#8A8A8A',marginBottom:4}}>
                        <span>Progress</span><span>{progress}% packed</span>
                      </div>
                      <div style={{height:6,background:'#EDE7D8',borderRadius:3}}>
                        <div style={{width:progress+'%',height:6,
                          background:progress===100?'#2E6B3A':'#556B2F',borderRadius:3}}/>
                      </div>
                    </div>
                    <div style={{textAlign:'center',fontSize:11,color:BRAND.gold,fontWeight:600}}>
                      Tap to record count →
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* PRODUCTION COUNT — detail & form */}
      {!result && screen === 'count' && selectedJO && (
        <div style={{width:'100%',maxWidth:800}}>
          <button onClick={()=>setSelectedJO(null)}
            style={{background:'none',border:'none',color:BRAND.cream,
              fontSize:13,cursor:'pointer',marginBottom:16}}>← Back to Job Orders</button>

          {/* Job header */}
          <div style={{background:'#3B2A21',borderRadius:12,padding:'16px 20px',
            marginBottom:20,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <div style={{fontSize:12,color:'rgba(242,239,231,.5)',marginBottom:2}}>
                {selectedJO.job_number}
              </div>
              <div style={{fontSize:16,fontWeight:600,color:'#A8893D'}}>
                {selectedJO.product_description}
              </div>
              <div style={{fontSize:11,color:'rgba(242,239,231,.6)',marginTop:4}}>
                Total Required: {selectedJO.quantity} units
              </div>
            </div>
          </div>

          {/* Stage summary */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(120px,1fr))',
            gap:8,marginBottom:20}}>
            {STAGES.map(stage=>(
              <div key={stage.key} style={{background:STAGE_COLORS[stage.key]||'#F9F9F9',
                borderRadius:8,padding:'10px 12px',textAlign:'center'}}>
                <div style={{fontSize:11,fontWeight:600,color:'#3B2A21',marginBottom:4}}>
                  {stage.label}
                </div>
                <div style={{fontSize:20,fontWeight:700,color:'#556B2F'}}>
                  {stageTotals[stage.key]||0}
                </div>
                <div style={{fontSize:9,color:'#8A8A8A'}}>of {selectedJO.quantity}</div>
              </div>
            ))}
          </div>

          {/* Record count form */}
          <div style={{background:'rgba(242,239,231,.95)',borderRadius:12,padding:20,marginBottom:20}}>
            <div style={{fontSize:13,fontWeight:600,color:'#3B2A21',marginBottom:16}}>
              + Record Production Count
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:8,marginBottom:12}}>
              {STAGES.map(stage=>(
                <button key={stage.key} onClick={()=>setCountForm({...countForm,production_stage:stage.key})}
                  style={{padding:'8px 6px',borderRadius:8,border:`2px solid ${countForm.production_stage===stage.key?'#556B2F':'transparent'}`,
                    background:countForm.production_stage===stage.key?'#556B2F':'#F2EFE7',
                    color:countForm.production_stage===stage.key?'#fff':'#3B2A21',
                    cursor:'pointer',fontSize:11,fontWeight:600}}>
                  {stage.label}
                </button>
              ))}
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
              <div>
                <label style={{fontSize:11,color:'#8A8A8A',display:'block',marginBottom:4}}>Quantity Completed *</label>
                <input type="number" min="1" value={countForm.quantity_completed}
                  onChange={e=>setCountForm({...countForm,quantity_completed:e.target.value})}
                  style={{width:'100%',padding:'10px',borderRadius:8,border:'1px solid #ddd',
                    fontSize:18,fontWeight:700,textAlign:'center',boxSizing:'border-box'}} />
              </div>
              <div>
                <label style={{fontSize:11,color:'#8A8A8A',display:'block',marginBottom:4}}>Rework Count</label>
                <input type="number" min="0" value={countForm.rework_count}
                  onChange={e=>setCountForm({...countForm,rework_count:e.target.value})}
                  style={{width:'100%',padding:'10px',borderRadius:8,border:'1px solid #ddd',
                    fontSize:18,fontWeight:700,textAlign:'center',boxSizing:'border-box'}} />
              </div>
            </div>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:11,color:'#8A8A8A',display:'block',marginBottom:4}}>Issues / Notes</label>
              <input value={countForm.issues}
                onChange={e=>setCountForm({...countForm,issues:e.target.value})}
                placeholder="Any issues or notes..."
                style={{width:'100%',padding:'10px',borderRadius:8,border:'1px solid #ddd',
                  fontSize:12,boxSizing:'border-box'}} />
            </div>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:11,color:'#8A8A8A',display:'block',marginBottom:4}}>Team Members (comma separated)</label>
              <input value={countForm.team_members}
                onChange={e=>setCountForm({...countForm,team_members:e.target.value})}
                placeholder="e.g. Bose, Roland, Feranmi"
                style={{width:'100%',padding:'10px',borderRadius:8,border:'1px solid #ddd',
                  fontSize:12,boxSizing:'border-box'}} />
            </div>
            <div style={{background:'#fff',borderRadius:8,padding:16,marginTop:8,border:'1px solid #E8E0D4'}}>
              <div style={{fontSize:11,color:'#8A8A8A',textAlign:'center',marginBottom:12}}>
                Enter your PIN to submit
              </div>
              <div style={{textAlign:'center'}}>
                <PinDots />
                {error && <div style={{background:'#FDEAEA',borderRadius:8,padding:8,
                  fontSize:12,color:'#8F2E24',textAlign:'center',marginBottom:10}}>{error}</div>}
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10,
                  maxWidth:220,margin:'0 auto'}}>
                  {[1,2,3,4,5,6,7,8,9,'',0,'⌫'].map((key,i)=>(
                    <button key={i} onClick={()=>{
                      if (key==='⌫') setPin(p=>p.slice(0,-1));
                      else if (key!=='') addPin(String(key));
                    }}
                    disabled={key===''}
                    style={{padding:'16px',borderRadius:12,border:'1px solid #E8E0D4',fontSize:20,
                      cursor:key===''?'default':'pointer',fontWeight:600,
                      background:key===''?'transparent':'#F9F8F5',
                      color:'#2C1F16',opacity:key===''?0:1}}>
                      {key}
                    </button>
                  ))}
                </div>
                <button onClick={submitCount} disabled={pin.length!==4||loading}
                  style={{marginTop:16,width:'100%',maxWidth:220,padding:'14px',
                    borderRadius:12,border:'none',
                    background:pin.length===4?BRAND.olive:'#E8E0D4',
                    color:pin.length===4?'#fff':'#8A8A8A',
                    fontSize:15,fontWeight:700,cursor:'pointer'}}>
                  {loading?'...' : 'Submit Count'}
                </button>
              </div>
            </div>
          </div>

          {/* Count history */}
          <div style={{fontSize:11,fontWeight:600,color:BRAND.cream,textTransform:'uppercase',
            letterSpacing:'.08em',marginBottom:12,opacity:.7}}>Count History</div>
          {counts.length === 0 ? (
            <div style={{color:'rgba(242,239,231,.4)',textAlign:'center',padding:20,fontSize:13}}>
              No counts recorded yet
            </div>
          ) : counts.map(count=>(
            <div key={count.id} style={{background:'rgba(242,239,231,.95)',
              borderRadius:10,padding:14,marginBottom:8}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                <div style={{flex:1}}>
                  <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
                    <span style={{fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:20,
                      background:STAGE_COLORS[count.production_stage]||'#F9F9F9',
                      color:'#3B2A21',textTransform:'uppercase'}}>
                      {count.production_stage?.replace(/_/g,' ')}
                    </span>
                    {count.verified_by ? (
                      <span style={{fontSize:9,fontWeight:700,padding:'2px 8px',borderRadius:20,
                        background:'#E8F5EB',color:'#2E6B3A'}}>✓ Verified</span>
                    ) : (
                      <span style={{fontSize:9,padding:'2px 8px',borderRadius:20,
                        background:'#FFF3DC',color:'#8B5E0A'}}>Unverified</span>
                    )}
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8,marginBottom:6}}>
                    <div>
                      <div style={{fontSize:9,color:'#8A8A8A',textTransform:'uppercase'}}>This Count</div>
                      <div style={{fontSize:18,fontWeight:700,color:'#556B2F'}}>{count.quantity_completed}</div>
                    </div>
                    <div>
                      <div style={{fontSize:9,color:'#8A8A8A',textTransform:'uppercase'}}>Cumulative</div>
                      <div style={{fontSize:18,fontWeight:700,color:'#3B2A21'}}>{count.cumulative_completed}</div>
                    </div>
                    <div>
                      <div style={{fontSize:9,color:'#8A8A8A',textTransform:'uppercase'}}>Remaining</div>
                      <div style={{fontSize:18,fontWeight:700,
                        color:count.quantity_remaining===0?'#2E6B3A':'#8F2E24'}}>
                        {count.quantity_remaining}
                      </div>
                    </div>
                  </div>
                  <div style={{fontSize:11,color:'#8A8A8A'}}>
                    By {count.counted_by_name} · {count.count_date} {count.count_time?.slice(0,5)}
                    {count.rework_count > 0 && <span style={{color:'#8F2E24'}}> · Rework: {count.rework_count}</span>}
                  </div>
                  {count.issues && (
                    <div style={{fontSize:11,color:'#8F2E24',marginTop:4}}>⚠ {count.issues}</div>
                  )}
                  {count.team_members?.length > 0 && (
                    <div style={{fontSize:11,color:'#8A8A8A',marginTop:4}}>
                      Team: {Array.isArray(count.team_members) ? count.team_members.join(', ') : count.team_members}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
